// extracted by mini-css-extract-plugin
export default {"slide":"Slide_slide__OBnyr"};